import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { CustomerService } from './customer.service'
import { NzMessageService } from 'ng-zorro-antd/message'
import { ActivatedRoute } from '@angular/router'
import { IExpress, IUser } from './customer.model'
import { UtilsService } from 'src/utils/utils.service'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  providers: [DatePipe],
})
export class CustomerComponent implements OnInit {
  constructor(private datePipe: DatePipe, private utilsService: UtilsService, private route: ActivatedRoute, private service: CustomerService, private message: NzMessageService, private cd: ChangeDetectorRef) {}
  isEdit: boolean = false
  priceFlag: boolean = false
  value: string = ''
  user = null
  customerUser = null
  couponList = [
    {
      name: '618',
      type: '满减',
      rule: '每满100减10元',
      checked: false,
    },
    {
      name: '双十一',
      type: '折扣',
      rule: '每满1000减990元',
      checked: false,
    },
    {
      name: '618',
      type: '满减',
      rule: '每满100减40元',
      checked: false,
    },
  ]
  isAllChecked = false
  isAllNoChecked = false
  // 发放优惠劵弹窗
  isVisible = false
  isOkLoading = false
  listOfAllData = [
    {
      id: 0,
      name: '618',
      type: '满减',
      rule: '每满100减10元',
      checked: false,
    },
    {
      id: 1,
      name: '双十一',
      type: '折扣',
      rule: '每满1000减990元',
      checked: false,
    },
    {
      id: 2,
      name: '618',
      type: '满减',
      rule: '每满100减40元',
      checked: false,
    },
  ]
  express: IExpress = {
    id: 0,
    expressNo: '',
    expressInfo: '',
    userInfo: '',
    expressCode: '',
    deliveryAt: 0,
    status: 0,
    receiverName: '',
    receiverPhone: '',
    address: '',
    province: '',
    city: '',
    district: '',
    expressData: '',
  }
  steps: { acceptAddress: string; acceptTime: string; opCode: string; remark: string }[] = []
  // 物流弹窗
  isLogisticsVisible: boolean = false
  // 容联传来的参数
  params = null
  // 分页
  total = 0
  size = 10
  page = 1
  orderTotal = 0
  orderSize = 10
  orderPage = 1
  // 优惠劵类型 1主动领取 2被动领取
  distributionType: number = 1

  // 表格选中行index
  selectIndex: number = null
  // 表格选中item
  coupon = null
  //订单
  orderList = []
  loading = false
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log('接收的参数--->', { ...params })
      this.params = params
      this.login()
      this.getOrderList()
      this.getUser()
    })
  }

  async getOrderList() {
    try {
      const params = {
        // uid: this.params.clientUserId,
        uid: 325, //调试
        page: this.orderPage,
        size: this.orderSize,
      }
      const { data, total } = await this.service.getOrderList(params)
      const { ordersInfoMap, userExpressMap, orders } = data
      orders.forEach((element) => {
        const userExpress = userExpressMap[element.id] || {}
        element.userExpress = userExpress
        if (element.userExpress instanceof Object) {
          const areaIdPath = this.utilsService.getJSONParse(element.userExpress.areaIdPath, [])
          if (Array.isArray(areaIdPath) && areaIdPath.length) {
            let address = ''
            areaIdPath.forEach((item) => {
              address += item.name
            })
            element.address = (address || '') + (element.userExpress && element.userExpress.address ? element.userExpress.address : '')
          }
        }
        // 订单信息
        const ordersInfo = ordersInfoMap[element.id] || []
        if (Array.isArray(ordersInfo) && ordersInfo.length) {
          ordersInfo.forEach((ordersItem, index) => {
            const goods = this.utilsService.getJSONParse(ordersItem.content, {})
            ordersInfo[index] = { ...ordersInfo[index], ...goods }
          })
        }
        element.goodsAmount = ordersInfo.length
        element.ordersInfo = ordersInfo
        // element.ordersInfo = ordersInfo.length && ordersInfo.length < 2 ? ordersInfo[0] || {} : ordersInfo
      })
      orders.forEach((item) => {
        item.realDesc = item.description
        item.description = item.description.length > 20 ? item.description.substr(0, 20) + '...' : item.description
      })
      this.orderList = orders
      this.orderTotal = total
      console.log('订单列表-->', this.orderList)
    } catch (error) {
      this.message.error(error.message)
    }
  }

  async updateRemark() {
    try {
      const params = {
        id:this.customerUser.id,
        remark:this.value
      }
      console.log('修改备注参数--》',params);
      const { data } = await this.service.updateRemark(params)
      this.message.success('备注成功')
      this.getUser()
      this.isEdit = false
    } catch (error) {
      this.message.error(error.message)
      this.isEdit = false
    }
  }

  onEdit() {
    this.isEdit = true
  }
  onSubmit() {
    this.updateRemark()
  }
  onPriceFlag() {
    this.priceFlag = !this.priceFlag
  }
  onSend() {
    this.isVisible = true
    this.getCoupon()
  }
  handleCancel(): void {
    this.isVisible = false
    this.isOkLoading = false
  }

  async getUser() {
    try {
      const params = {
        exten: this.params.exten,
      }
      const { data } = await this.service.getUser(this.params.clientUserId, params)
      this.user = data.user
      // console.log(res)
      this.customerUser = data.customerUser
      console.log('user--->', this.user, this.customerUser)
    } catch (error) {
      this.message.error(error.message)
    }
  }

  async getCoupon() {
    try {
      this.loading = true
      const params = {
        distributionType: this.distributionType,
        page: this.page,
        size: this.size,
      }
      const { data, total } = await this.service.getCouponList(params)
      data.forEach((item) => {
        console.log(item)
        item.category = item.category == 1 ? '满减' : '折扣'
      })
      this.listOfAllData = data
      this.total = total
      console.log('优惠劵列表--》', data)
      this.loading = false
    } catch (error) {
      this.message.error(error.message)
      this.loading = false
    }
  }
  pageChange(event): void {
    this.page = event
    this.getCoupon()
  }
  orderPageChange(event): void {
    this.orderPage = event
    this.getOrderList()
  }
  checkNo(index) {
    this.listOfAllData[index].checked = !this.listOfAllData[index].checked
    this.cd.detectChanges()
    console.log(this.listOfAllData)
  }
  checkNoAll() {
    this.listOfAllData.forEach((item) => {
      item.checked = this.isAllNoChecked
    })
    this.cd.detectChanges()
  }
  check(index) {
    this.couponList[index].checked = !this.couponList[index].checked
    this.cd.detectChanges()
    console.log(this.couponList)
  }
  checkAll() {
    this.couponList.forEach((item) => {
      item.checked = this.isAllChecked
    })
    this.cd.detectChanges()
  }
  async handleOk(): Promise<any> {
    try {
      this.isOkLoading = true
      // const res = await this.service.addAddress(this.validateForm.value)
      let data = {
        // 要发送的卡片数据对象
        showCardInfoMsg: '1',
        title: this.coupon.name,
        sub_title: this.coupon.description,
        img: this.coupon.image,
        // attr_one: { color: '#000000', content: ''},
        // attr_two: { color: '#000000', content:  ''},
        price: this.coupon.threshold + '-' + this.coupon.discount,
        other_title_one: '',
        other_title_two: '',
        other_title_three: '',
        target: '',
      }
      const params = {
        couponId: this.coupon.id,
        id: this.params.clientUserId,
        exten: this.params.exten,
      }
      const { data: res } = await this.service.sendIssue(params)
      window.parent.postMessage(data, '*')
      this.isVisible = false
      this.isOkLoading = false
    } catch (error) {
      this.message.error(error.message)
    }
  }

  sendOrder(item) {
    let data = {
      // 要发送的卡片数据对象
      showCardInfoMsg: '1',
      title: item.ordersInfo[0].spuTitle,
      sub_title: item.ordersInfo[0].sku.title,
      img: item.ordersInfo[0].sku.pic,
      // attr_one: { color: '#000000', content: ''},
      attr_two: { color: '#000000', content: '×' + item.ordersInfo[0].cnt },
      price: item.ordersInfo[0].sku.price,
      other_title_one: '订单编号:' + item.ordersNo,
      other_title_two: '创建时间:' + this.datePipe.transform(item.createAt, 'yyyy-MM-dd HH:mm:ss'),
      other_title_three: '',
      target: '',
    }
    window.parent.postMessage(data, '*')
  }

  onSelect(data) {
    this.selectIndex = data.id
    this.coupon = data
  }
  // 优惠劵tab面板切换
  changeTab(e) {
    this.distributionType = ++e
    console.log(e, this.distributionType)
    this.page = 1
    this.getCoupon()
  }

  logisticHandleCancel() {
    this.isLogisticsVisible = false
  }

  logisticHandleOk() {
    this.isLogisticsVisible = false
  }

  async onExpress(id) {
    try {
      id = 597
      this.isLogisticsVisible = true
      const { data } = await this.service.getExpress(id)
      this.express = data
      console.log(this.express.expressData)
      console.log(JSON.parse(this.express.expressData))
      this.steps = JSON.parse(this.express.expressData)[0].routes
      console.log(this.steps)
      this.steps = this.steps.reverse()
    } catch (error) {}
  }

  async login() {
    try {
      const params = {
        exten: this.params.exten,
        token: this.params.token,
        tokenId: this.params.tokenId,
      }
      const { data } = await this.service.login(params)
      console.log('登录--》', data)
      localStorage.setItem('merchantId', data.merchants[0].id)
      localStorage.setItem('token', data.token)
    } catch (error) {
      this.message.error(error.message)
    }
  }
}
